// @flow
import React from 'react';

import {
  CheckedList,
  type CheckedListProps,
} from 'Components/frameworks/checked-list/CheckedList.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  ...$Exact<CheckedListProps>,
  id?: string,
};

export function ChecklistLine({ id, ...props }: Props) {
  return (
    <SiteContainer id={id} className="Line">
      <CheckedList {...props} />
    </SiteContainer>
  );
}
